/**
 * THIS FILE CONTAINS CODEGEN OUTPUT. DO NOT MODIFY MANUALLY
 *
 * Default and required style tokens.
 */
import * as t from 'io-ts';
export const schemaId = 'DesignTokens';
export const AspectRatio = t.type({
    '1:1': t.type({
        value: t.string,
    }, '1:1'),
    '2:3': t.type({
        value: t.string,
    }, '2:3'),
    '4:3': t.type({
        value: t.string,
    }, '4:3'),
    '4:5': t.type({
        value: t.string,
    }, '4:5'),
    '16:9': t.type({
        value: t.string,
    }, '16:9'),
    '9:16': t.type({
        value: t.string,
    }, '9:16'),
}, 'AspectRatio');
export const DesignTokenWithDimension = t.intersection([
    t.type({
        value: t.unknown,
    }),
    t.partial({
        type: t.literal('dimension'),
    }),
], 'DesignTokenWithDimension');
export const BreakpointAndGutter = t.type({
    breakpoint: DesignTokenWithDimension,
    gutter: DesignTokenWithDimension,
}, 'BreakpointAndGutter');
export const DesignTokenWithColor = t.intersection([
    t.type({
        value: t.string,
    }),
    t.partial({
        type: t.literal('color'),
    }),
], 'DesignTokenWithColor');
export const DesignTokenWithString = t.type({
    value: t.string,
}, 'DesignTokenWithString');
export const ColorStyleWidthWithNoAdditionalProperties = t.type({
    color: DesignTokenWithColor,
    style: DesignTokenWithString,
    width: DesignTokenWithDimension,
}, 'ColorStyleWidthWithNoAdditionalProperties');
export const ColorBackgroundBorder = t.type({
    color: DesignTokenWithColor,
    background: DesignTokenWithColor,
    border: t.type({
        color: DesignTokenWithColor,
    }, 'border'),
}, 'ColorBackgroundBorder');
export const ColorBackgroundBorderWithNoAdditionalProperties = t.intersection([
    t.partial({
        color: t.unknown,
        background: t.unknown,
        border: t.unknown,
    }, 'ColorBackgroundBorderWithNoAdditionalProperties'),
    ColorBackgroundBorder,
]);
export const ColorBackgroundBorderOutlineWithNoAdditionalProperties = t.intersection([
    t.type({
        outline: ColorStyleWidthWithNoAdditionalProperties,
        color: t.unknown,
        background: t.unknown,
        border: t.unknown,
    }, 'ColorBackgroundBorderOutlineWithNoAdditionalProperties'),
    ColorBackgroundBorder,
]);
export const BtnOnePart = t.type({
    padding: DesignTokenWithDimension,
    color: DesignTokenWithColor,
    background: DesignTokenWithColor,
    border: ColorStyleWidthWithNoAdditionalProperties,
    hover: ColorBackgroundBorderWithNoAdditionalProperties,
    active: ColorBackgroundBorderWithNoAdditionalProperties,
    focus: ColorBackgroundBorderOutlineWithNoAdditionalProperties,
}, 'BtnOnePart');
export const BtnOnePartAndDarkWithNoAdditionalProperties = t.intersection([
    t.intersection([
        t.type({
            dark: t.intersection([
                t.partial({
                    padding: t.unknown,
                    color: t.unknown,
                    background: t.unknown,
                    border: t.unknown,
                    hover: t.unknown,
                    active: t.unknown,
                    focus: t.unknown,
                }, 'dark'),
                BtnOnePart,
            ]),
        }),
        t.partial({
            padding: t.unknown,
            color: t.unknown,
            background: t.unknown,
            border: t.unknown,
            hover: t.unknown,
            active: t.unknown,
            focus: t.unknown,
        }),
    ], 'BtnOnePartAndDarkWithNoAdditionalProperties'),
    BtnOnePart,
]);
export const BtnIconsExceptSize = t.type({
    color: DesignTokenWithColor,
    background: DesignTokenWithColor,
    border: ColorStyleWidthWithNoAdditionalProperties,
    hover: ColorBackgroundBorderWithNoAdditionalProperties,
    active: ColorBackgroundBorderWithNoAdditionalProperties,
    focus: ColorBackgroundBorderOutlineWithNoAdditionalProperties,
}, 'BtnIconsExceptSize');
export const BtnIcons = t.intersection([
    t.type({
        size: DesignTokenWithDimension,
    }, 'BtnIcons'),
    BtnIconsExceptSize,
]);
export const BtnIconsAndDark = t.intersection([
    t.type({
        dark: t.intersection([
            t.partial({
                color: t.unknown,
                background: t.unknown,
                border: t.unknown,
                hover: t.unknown,
                active: t.unknown,
                focus: t.unknown,
            }, 'dark'),
            BtnIconsExceptSize,
        ]),
    }),
    t.partial({
        size: t.unknown,
        color: t.unknown,
        background: t.unknown,
        border: t.unknown,
        hover: t.unknown,
        active: t.unknown,
        focus: t.unknown,
    }),
], 'BtnIconsAndDark');
export const ColorDecoration = t.type({
    color: DesignTokenWithColor,
    decoration: t.type({
        color: DesignTokenWithColor,
    }, 'decoration'),
}, 'ColorDecoration');
export const ColorDecorationWithNoAdditionalProperties = t.intersection([
    t.partial({
        color: t.unknown,
        decoration: t.unknown,
    }, 'ColorDecorationWithNoAdditionalProperties'),
    ColorDecoration,
]);
export const BtnLink = t.type({
    color: DesignTokenWithColor,
    decoration: t.type({
        color: DesignTokenWithColor,
    }, 'decoration'),
    hover: t.type({
        color: DesignTokenWithColor,
        decoration: t.type({
            color: DesignTokenWithColor,
        }, 'decoration'),
    }, 'hover'),
    active: ColorDecorationWithNoAdditionalProperties,
    focus: t.intersection([
        t.type({
            outline: ColorStyleWidthWithNoAdditionalProperties,
            color: t.unknown,
            decoration: t.unknown,
        }, 'focus'),
        ColorDecoration,
    ]),
}, 'BtnLink');
export const BtnLinkAndDarkWithNoAdditionalProperties = t.intersection([
    t.intersection([
        t.type({
            dark: t.intersection([
                t.partial({
                    color: t.unknown,
                    decoration: t.unknown,
                    hover: t.unknown,
                    active: t.unknown,
                    focus: t.unknown,
                }, 'dark'),
                BtnLink,
            ]),
        }),
        t.partial({
            color: t.unknown,
            decoration: t.unknown,
            hover: t.unknown,
            active: t.unknown,
            focus: t.unknown,
        }),
    ], 'BtnLinkAndDarkWithNoAdditionalProperties'),
    BtnLink,
]);
export const DesignTokenWithFontFamily = t.intersection([
    t.type({
        value: t.union([t.string, t.array(t.string)], 'value'),
    }),
    t.partial({
        type: t.literal('fontFamily'),
    }),
], 'DesignTokenWithFontFamily');
export const DesignTokenWithFontWeight = t.intersection([
    t.type({
        value: t.string,
    }),
    t.partial({
        type: t.literal('fontWeight'),
    }),
], 'DesignTokenWithFontWeight');
export const DesignTokenWithNumber = t.intersection([
    t.type({
        value: t.union([t.string, t.number], 'value'),
    }),
    t.partial({
        type: t.literal('number'),
    }),
], 'DesignTokenWithNumber');
export const FontSizeSpacingWeight = t.type({
    size: DesignTokenWithDimension,
    weight: DesignTokenWithFontWeight,
    lineHeight: DesignTokenWithNumber,
    letterSpacing: DesignTokenWithDimension,
}, 'FontSizeSpacingWeight');
export const FontProperties = t.intersection([
    t.type({
        family: DesignTokenWithFontFamily,
    }, 'FontProperties'),
    FontSizeSpacingWeight,
]);
export const FontPropertiesAndNoAdditionalProperties = t.intersection([
    t.partial({
        size: t.unknown,
        weight: t.unknown,
        lineHeight: t.unknown,
        letterSpacing: t.unknown,
        family: t.unknown,
    }, 'FontPropertiesAndNoAdditionalProperties'),
    FontProperties,
]);
export const FontPropertiesAndDesktop = t.intersection([
    t.partial({
        desktop: FontPropertiesAndNoAdditionalProperties,
    }, 'FontPropertiesAndDesktop'),
    FontProperties,
]);
export const FontPropertiesAndDesktopAndNoAdditionalProperties = t.intersection([
    t.partial({
        desktop: t.unknown,
        size: t.unknown,
        weight: t.unknown,
        lineHeight: t.unknown,
        letterSpacing: t.unknown,
        family: t.unknown,
    }, 'FontPropertiesAndDesktopAndNoAdditionalProperties'),
    FontPropertiesAndDesktop,
]);
export const CardTitleTypography = t.intersection([
    t.intersection([
        t.type({
            l: FontPropertiesAndNoAdditionalProperties,
            stacked: t.intersection([
                t.intersection([
                    t.type({
                        xs: FontPropertiesAndNoAdditionalProperties,
                        s: t.intersection([
                            t.intersection([
                                t.type({
                                    'type-large': FontPropertiesAndNoAdditionalProperties,
                                }),
                                t.partial({
                                    size: t.unknown,
                                    weight: t.unknown,
                                    lineHeight: t.unknown,
                                    letterSpacing: t.unknown,
                                    family: t.unknown,
                                }),
                            ], 's'),
                            FontProperties,
                        ]),
                        m: FontPropertiesAndNoAdditionalProperties,
                        l: FontPropertiesAndNoAdditionalProperties,
                        xl: FontPropertiesAndNoAdditionalProperties,
                    }),
                    t.partial({
                        size: t.unknown,
                        weight: t.unknown,
                        lineHeight: t.unknown,
                        letterSpacing: t.unknown,
                        family: t.unknown,
                    }),
                ], 'stacked'),
                FontProperties,
            ]),
        }),
        t.partial({
            '50-50': FontPropertiesAndDesktopAndNoAdditionalProperties,
            desktop: t.unknown,
            size: t.unknown,
            weight: t.unknown,
            lineHeight: t.unknown,
            letterSpacing: t.unknown,
            family: t.unknown,
        }),
    ], 'CardTitleTypography'),
    FontPropertiesAndDesktop,
]);
export const defaultCardTitleTypography = {
    size: { value: '{typography.h.2xs.size.value}' },
    weight: { value: '{typography.h.2xs.weight.value}' },
    lineHeight: { value: '{typography.h.2xs.lineHeight.value}' },
    letterSpacing: { value: '{typography.h.2xs.letterSpacing.value}' },
    family: { value: '{typography.h.2xs.family.value}' },
    desktop: {
        size: { value: '{typography.h.2xs.desktop.size.value}' },
        weight: { value: '{typography.h.2xs.desktop.weight.value}' },
        lineHeight: { value: '{typography.h.2xs.desktop.lineHeight.value}' },
        letterSpacing: { value: '{typography.h.2xs.desktop.letterSpacing.value}' },
        family: { value: '{typography.h.2xs.desktop.family.value}' },
    },
    l: {
        size: { value: '{typography.h.s.desktop.size.value}' },
        weight: { value: '{typography.h.s.desktop.weight.value}' },
        lineHeight: { value: '{typography.h.s.desktop.lineHeight.value}' },
        letterSpacing: { value: '{typography.h.s.desktop.letterSpacing.value}' },
        family: { value: '{typography.h.s.desktop.family.value}' },
    },
    stacked: {
        size: { value: '{typography.h.2xs.size.value}' },
        weight: { value: '{typography.h.2xs.weight.value}' },
        lineHeight: { value: '{typography.h.2xs.lineHeight.value}' },
        letterSpacing: { value: '{typography.h.2xs.letterSpacing.value}' },
        family: { value: '{typography.h.2xs.family.value}' },
        xs: {
            size: { value: '{typography.h.2xs.desktop.size.value}' },
            weight: { value: '{typography.h.2xs.desktop.weight.value}' },
            lineHeight: { value: '{typography.h.2xs.desktop.lineHeight.value}' },
            letterSpacing: { value: '{typography.h.2xs.desktop.letterSpacing.value}' },
            family: { value: '{typography.h.2xs.desktop.family.value}' },
        },
        s: {
            size: { value: '{typography.h.xs.size.value}' },
            weight: { value: '{typography.h.xs.weight.value}' },
            lineHeight: { value: '{typography.h.xs.lineHeight.value}' },
            letterSpacing: { value: '{typography.h.xs.letterSpacing.value}' },
            family: { value: '{typography.h.xs.family.value}' },
            'type-large': {
                size: { value: '{typography.h.m.size.value}' },
                weight: { value: '{typography.h.m.weight.value}' },
                lineHeight: { value: '{typography.h.m.lineHeight.value}' },
                letterSpacing: { value: '{typography.h.m.letterSpacing.value}' },
                family: { value: '{typography.h.m.family.value}' },
            },
        },
        m: {
            size: { value: '{typography.h.xs.desktop.size.value}' },
            weight: { value: '{typography.h.xs.desktop.weight.value}' },
            lineHeight: { value: '{typography.h.xs.desktop.lineHeight.value}' },
            letterSpacing: { value: '{typography.h.xs.desktop.letterSpacing.value}' },
            family: { value: '{typography.h.xs.desktop.family.value}' },
        },
        l: {
            size: { value: '{typography.h.s.desktop.size.value}' },
            weight: { value: '{typography.h.s.desktop.weight.value}' },
            lineHeight: { value: '{typography.h.s.desktop.lineHeight.value}' },
            letterSpacing: { value: '{typography.h.s.desktop.letterSpacing.value}' },
            family: { value: '{typography.h.s.desktop.family.value}' },
        },
        xl: {
            size: { value: '{typography.h.m.desktop.size.value}' },
            weight: { value: '{typography.h.m.desktop.weight.value}' },
            lineHeight: { value: '{typography.h.m.desktop.lineHeight.value}' },
            letterSpacing: { value: '{typography.h.m.desktop.letterSpacing.value}' },
            family: { value: '{typography.h.m.desktop.family.value}' },
        },
    },
    '50-50': {
        size: { value: '{typography.h.m.size.value}' },
        weight: { value: '{typography.h.m.weight.value}' },
        lineHeight: { value: '{typography.h.m.lineHeight.value}' },
        letterSpacing: { value: '{typography.h.m.letterSpacing.value}' },
        family: { value: '{typography.h.m.family.value}' },
        desktop: {
            size: { value: '{typography.h.m.desktop.size.value}' },
            weight: { value: '{typography.h.m.desktop.weight.value}' },
            lineHeight: { value: '{typography.h.m.desktop.lineHeight.value}' },
            letterSpacing: { value: '{typography.h.m.desktop.letterSpacing.value}' },
            family: { value: '{typography.h.m.desktop.family.value}' },
        },
    },
};
export const CardTypographyOverrideWithNoAdditionalProperties = t.type({
    title: FontPropertiesAndDesktopAndNoAdditionalProperties,
    subhead: FontPropertiesAndDesktopAndNoAdditionalProperties,
    body: FontPropertiesAndDesktopAndNoAdditionalProperties,
    date: FontPropertiesAndDesktopAndNoAdditionalProperties,
    counts: FontPropertiesAndDesktopAndNoAdditionalProperties,
    category: FontPropertiesAndDesktopAndNoAdditionalProperties,
    contributor: t.type({
        name: FontPropertiesAndDesktopAndNoAdditionalProperties,
        role: FontPropertiesAndDesktopAndNoAdditionalProperties,
    }, 'contributor'),
}, 'CardTypographyOverrideWithNoAdditionalProperties');
export const ColorThemeButton = t.type({
    background: DesignTokenWithColor,
    text: DesignTokenWithColor,
}, 'ColorThemeButton');
export const ColorPairing = t.type({
    background: DesignTokenWithColor,
    text: DesignTokenWithColor,
    caption: DesignTokenWithColor,
    button: ColorThemeButton,
    'is-dark-theme': DesignTokenWithNumber,
}, 'ColorPairing');
export const DesignTokenWithFlag = t.type({
    value: t.union([t.literal(0), t.literal(1)], 'value'),
}, 'DesignTokenWithFlag');
export const LinkAndPseudoSelectorColors = t.type({
    link: DesignTokenWithColor,
    'link-hover': DesignTokenWithColor,
    'link-active': DesignTokenWithColor,
    'link-focus': DesignTokenWithColor,
}, 'LinkAndPseudoSelectorColors');
export const ColorTheme = t.intersection([
    t.type({
        background: DesignTokenWithColor,
        caption: DesignTokenWithColor,
        text: DesignTokenWithColor,
        'is-dark-theme': DesignTokenWithFlag,
        link: t.unknown,
        'link-hover': t.unknown,
        'link-active': t.unknown,
        'link-focus': t.unknown,
        'link-focus-outline': ColorStyleWidthWithNoAdditionalProperties,
        'hero-accent': DesignTokenWithColor,
        filled: t.type({
            component: t.type({
                background: DesignTokenWithColor,
            }, 'component'),
        }, 'filled'),
    }, 'ColorTheme'),
    LinkAndPseudoSelectorColors,
]);
export const Color = t.partial({
    link: DesignTokenWithColor,
    theme1: DesignTokenWithColor,
    theme2: DesignTokenWithColor,
    accent1: DesignTokenWithColor,
    accent2: DesignTokenWithColor,
    accent3: DesignTokenWithColor,
    accent4: DesignTokenWithColor,
    neutral: t.partial({
        black: DesignTokenWithColor,
        white: DesignTokenWithColor,
        dark: t.partial({
            '5': DesignTokenWithColor,
            '10': DesignTokenWithColor,
            '20': DesignTokenWithColor,
            '40': DesignTokenWithColor,
            '70': DesignTokenWithColor,
            '85': DesignTokenWithColor,
        }, 'dark'),
        light: t.partial({
            '5': DesignTokenWithColor,
            '10': DesignTokenWithColor,
            '20': DesignTokenWithColor,
            '40': DesignTokenWithColor,
            '70': DesignTokenWithColor,
            '85': DesignTokenWithColor,
        }, 'light'),
    }, 'neutral'),
    pairing: t.type({
        '1': ColorPairing,
        '2': ColorPairing,
        '3': ColorPairing,
        '4': ColorPairing,
    }, 'pairing'),
    util: t.type({
        blue: t.partial({
            value: t.string,
        }, 'blue'),
        red: t.partial({
            value: t.string,
        }, 'red'),
        yellow: t.partial({
            value: t.string,
        }, 'yellow'),
        green: t.partial({
            value: t.string,
        }, 'green'),
        purple: t.partial({
            value: t.string,
        }, 'purple'),
        dark: t.type({
            blue: t.partial({
                value: t.string,
            }, 'blue'),
            red: t.partial({
                value: t.string,
            }, 'red'),
            yellow: t.partial({
                value: t.string,
            }, 'yellow'),
            green: t.partial({
                value: t.string,
            }, 'green'),
            purple: t.partial({
                value: t.string,
            }, 'purple'),
        }, 'dark'),
    }, 'util'),
    theme: t.intersection([
        t.intersection([
            t.type({
                dark: t.intersection([
                    t.partial({
                        button: ColorThemeButton,
                        background: t.unknown,
                        caption: t.unknown,
                        text: t.unknown,
                        link: t.unknown,
                        'link-hover': t.unknown,
                        'link-active': t.unknown,
                        'link-focus': t.unknown,
                        'link-focus-outline': t.unknown,
                        'hero-accent': t.unknown,
                        filled: t.unknown,
                        'is-dark-theme': t.unknown,
                    }, 'dark'),
                    ColorTheme,
                ]),
            }),
            t.partial({
                background: t.unknown,
                caption: t.unknown,
                text: t.unknown,
                link: t.unknown,
                'link-hover': t.unknown,
                'link-active': t.unknown,
                'link-focus': t.unknown,
                'link-focus-outline': t.unknown,
                'hero-accent': t.unknown,
                filled: t.unknown,
                'is-dark-theme': t.unknown,
            }),
        ], 'theme'),
        ColorTheme,
    ]),
}, 'Color');
export const ColorOfTextAndBackground = t.type({
    text: DesignTokenWithColor,
    background: DesignTokenWithColor,
}, 'ColorOfTextAndBackground');
export const ColorOfTextAndBackgroundWithNoAdditionalProperties = t.intersection([
    t.partial({
        text: t.unknown,
        background: t.unknown,
    }, 'ColorOfTextAndBackgroundWithNoAdditionalProperties'),
    ColorOfTextAndBackground,
]);
export const ColorOfTextWithNoAdditionalProperties = t.type({
    text: DesignTokenWithColor,
}, 'ColorOfTextWithNoAdditionalProperties');
export const Theme = t.union([
    t.literal('default'),
    t.literal('dark'),
    t.literal('pairing1'),
    t.literal('pairing2'),
    t.literal('pairing3'),
    t.literal('pairing4'),
], 'Theme');
export const defaultTheme = 'default';
export const ThemeSelector = t.type({
    theme: Theme,
}, 'ThemeSelector');
export const DesignTokenWithCubicBezier = t.type({
    type: t.literal('cubicBezier'),
    value: t.array(t.number),
}, 'DesignTokenWithCubicBezier');
export const DesignTokenWithDuration = t.type({
    type: t.literal('duration'),
    value: t.type({
        value: t.number,
        unit: t.union([t.literal('ms'), t.literal('s')], 'unit'),
    }, 'value'),
}, 'DesignTokenWithDuration');
export const FontSizeSpacingWeightAndNoAdditionalProperties = t.intersection([
    t.partial({
        size: t.unknown,
        weight: t.unknown,
        lineHeight: t.unknown,
        letterSpacing: t.unknown,
    }, 'FontSizeSpacingWeightAndNoAdditionalProperties'),
    FontSizeSpacingWeight,
]);
export const FontPropertiesAndDesktopButNoFamilyAndNoAdditionalProperties = t.intersection([
    t.intersection([
        t.type({
            desktop: FontSizeSpacingWeightAndNoAdditionalProperties,
        }),
        t.partial({
            size: t.unknown,
            weight: t.unknown,
            lineHeight: t.unknown,
            letterSpacing: t.unknown,
            family: t.unknown,
        }),
    ], 'FontPropertiesAndDesktopButNoFamilyAndNoAdditionalProperties'),
    FontProperties,
]);
export const FormInputColorPalette = t.partial({
    default: DesignTokenWithColor,
    placeholder: DesignTokenWithColor,
    label: DesignTokenWithColor,
    error: DesignTokenWithColor,
    helper: DesignTokenWithColor,
    background: t.type({
        default: DesignTokenWithColor,
        focus: DesignTokenWithColor,
        hover: DesignTokenWithColor,
        filled: DesignTokenWithColor,
    }, 'background'),
    border: t.type({
        default: DesignTokenWithColor,
        focus: DesignTokenWithColor,
        hover: DesignTokenWithColor,
        active: DesignTokenWithColor,
        error: DesignTokenWithColor,
        success: DesignTokenWithColor,
    }, 'border'),
    focus: t.type({
        outline: t.type({
            color: DesignTokenWithColor,
        }, 'outline'),
    }, 'focus'),
}, 'FormInputColorPalette');
export const FormInputDarkColorPaletteWithNoAdditionalProperties = t.type({
    default: DesignTokenWithColor,
    placeholder: DesignTokenWithColor,
    label: DesignTokenWithColor,
    error: DesignTokenWithColor,
    helper: DesignTokenWithColor,
    background: t.type({
        default: DesignTokenWithColor,
        focus: DesignTokenWithColor,
        hover: DesignTokenWithColor,
    }, 'background'),
    border: t.type({
        default: DesignTokenWithColor,
        focus: DesignTokenWithColor,
        hover: DesignTokenWithColor,
        active: DesignTokenWithColor,
        error: DesignTokenWithColor,
        success: DesignTokenWithColor,
    }, 'border'),
    focus: t.type({
        outline: t.type({
            color: DesignTokenWithColor,
        }, 'outline'),
    }, 'focus'),
}, 'FormInputDarkColorPaletteWithNoAdditionalProperties');
export const Link = t.intersection([
    t.type({
        'text-decoration': DesignTokenWithString,
        desktop: FontPropertiesAndNoAdditionalProperties,
        size: t.unknown,
        weight: t.unknown,
        lineHeight: t.unknown,
        letterSpacing: t.unknown,
        family: t.unknown,
    }, 'Link'),
    FontProperties,
]);
export const SpacingAndDesktopWithNoAdditionalProperties = t.type({
    spacing: DesignTokenWithDimension,
    desktop: t.type({
        spacing: DesignTokenWithDimension,
    }, 'desktop'),
}, 'SpacingAndDesktopWithNoAdditionalProperties');
export const Typeface = t.type({
    family: DesignTokenWithFontFamily,
    weight: t.type({
        normal: DesignTokenWithFontWeight,
        medium: DesignTokenWithFontWeight,
        bold: DesignTokenWithFontWeight,
    }, 'weight'),
}, 'Typeface');
export const DesignTokens = t.type({
    ar: AspectRatio,
    breadcrumbs: t.partial({
        color: t.intersection([
            t.intersection([
                t.type({
                    default: DesignTokenWithColor,
                }),
                t.partial({
                    link: t.unknown,
                    'link-hover': t.unknown,
                    'link-active': t.unknown,
                    'link-focus': t.unknown,
                }),
            ], 'color'),
            LinkAndPseudoSelectorColors,
        ]),
        typography: t.type({
            link: t.intersection([
                t.partial({
                    focus: t.type({
                        outline: t.type({
                            color: DesignTokenWithColor,
                            value: t.string,
                        }, 'outline'),
                    }, 'focus'),
                    desktop: FontPropertiesAndNoAdditionalProperties,
                    size: t.unknown,
                    weight: t.unknown,
                    lineHeight: t.unknown,
                    letterSpacing: t.unknown,
                    family: t.unknown,
                }, 'link'),
                FontProperties,
            ]),
        }, 'typography'),
        vertical: SpacingAndDesktopWithNoAdditionalProperties,
    }, 'breadcrumbs'),
    btn: t.partial({
        primary: BtnOnePartAndDarkWithNoAdditionalProperties,
        secondary: t.intersection([
            t.intersection([
                t.type({
                    dark: t.type({
                        color: DesignTokenWithColor,
                        background: DesignTokenWithColor,
                        border: ColorStyleWidthWithNoAdditionalProperties,
                        hover: ColorBackgroundBorderWithNoAdditionalProperties,
                        active: ColorBackgroundBorderWithNoAdditionalProperties,
                        focus: ColorBackgroundBorderOutlineWithNoAdditionalProperties,
                    }, 'dark'),
                }),
                t.partial({
                    padding: t.unknown,
                    color: t.unknown,
                    background: t.unknown,
                    border: t.unknown,
                    hover: t.unknown,
                    active: t.unknown,
                    focus: t.unknown,
                }),
            ], 'secondary'),
            BtnOnePart,
        ]),
        link: BtnLinkAndDarkWithNoAdditionalProperties,
        icons: t.intersection([
            t.intersection([
                t.type({
                    l: t.type({
                        size: DesignTokenWithDimension,
                    }, 'l'),
                }),
                t.partial({
                    dark: t.unknown,
                    size: t.unknown,
                    color: t.unknown,
                    background: t.unknown,
                    border: t.unknown,
                    hover: t.unknown,
                    active: t.unknown,
                    focus: t.unknown,
                }),
            ], 'icons'),
            BtnIconsAndDark,
        ]),
    }, 'btn'),
    card: t.type({
        color: t.type({
            background: DesignTokenWithColor,
            text: DesignTokenWithColor,
            date: DesignTokenWithColor,
            counts: DesignTokenWithColor,
            category: DesignTokenWithColor,
            contributor: t.type({
                name: DesignTokenWithColor,
                role: DesignTokenWithColor,
            }, 'contributor'),
            caption: DesignTokenWithColor,
            cta: DesignTokenWithColor,
        }, 'color'),
        typography: t.type({
            body: FontPropertiesAndNoAdditionalProperties,
            caption: FontPropertiesAndDesktopAndNoAdditionalProperties,
            category: FontPropertiesAndDesktopAndNoAdditionalProperties,
            counts: FontPropertiesAndDesktopAndNoAdditionalProperties,
            contributor: t.type({
                name: FontPropertiesAndDesktopAndNoAdditionalProperties,
                role: FontPropertiesAndDesktopAndNoAdditionalProperties,
            }, 'contributor'),
            title: CardTitleTypography,
            date: FontPropertiesAndDesktopAndNoAdditionalProperties,
            subhead: FontPropertiesAndNoAdditionalProperties,
            m: CardTypographyOverrideWithNoAdditionalProperties,
            l: CardTypographyOverrideWithNoAdditionalProperties,
            xl: CardTypographyOverrideWithNoAdditionalProperties,
        }, 'typography'),
    }, 'card'),
    carousel: t.type({
        vertical: SpacingAndDesktopWithNoAdditionalProperties,
        color: t.type({
            background: DesignTokenWithColor,
            text: DesignTokenWithColor,
        }, 'color'),
        typography: t.type({
            pagination: FontPropertiesAndDesktopAndNoAdditionalProperties,
            subhead: FontPropertiesAndDesktopAndNoAdditionalProperties,
            title: FontPropertiesAndDesktopAndNoAdditionalProperties,
        }, 'typography'),
    }, 'carousel'),
    color: Color,
    disclaimer: t.type({
        'vertical-spacing': DesignTokenWithDimension,
        color: t.type({
            text: DesignTokenWithColor,
            background: DesignTokenWithColor,
        }, 'color'),
        typography: t.type({
            size: DesignTokenWithDimension,
            weight: DesignTokenWithFontWeight,
            lineHeight: DesignTokenWithNumber,
            letterSpacing: DesignTokenWithDimension,
            family: DesignTokenWithFontFamily,
        }, 'typography'),
    }, 'disclaimer'),
    elevation: t.type({
        level: t.type({
            '1': DesignTokenWithString,
            '2': DesignTokenWithString,
            '3': DesignTokenWithString,
            '4': DesignTokenWithString,
        }, 'level'),
    }, 'elevation'),
    footer: t.type({
        color: t.intersection([
            t.type({
                background: DesignTokenWithColor,
                text: DesignTokenWithColor,
                link: t.unknown,
                'link-hover': t.unknown,
                'link-active': t.unknown,
                'link-focus': t.unknown,
            }, 'color'),
            LinkAndPseudoSelectorColors,
        ]),
        separator: t.type({
            color: DesignTokenWithColor,
            thickness: DesignTokenWithDimension,
        }, 'separator'),
        typography: t.type({
            link: t.intersection([
                t.intersection([
                    t.type({
                        focus: t.type({
                            outline: ColorStyleWidthWithNoAdditionalProperties,
                        }, 'focus'),
                        l1: FontPropertiesAndDesktopAndNoAdditionalProperties,
                        l2: FontPropertiesAndDesktopAndNoAdditionalProperties,
                    }),
                    t.partial({
                        desktop: t.unknown,
                        size: t.unknown,
                        weight: t.unknown,
                        lineHeight: t.unknown,
                        letterSpacing: t.unknown,
                        family: t.unknown,
                    }),
                ], 'link'),
                FontPropertiesAndDesktop,
            ]),
            text: FontPropertiesAndDesktopAndNoAdditionalProperties,
        }, 'typography'),
        vertical: SpacingAndDesktopWithNoAdditionalProperties,
    }, 'footer'),
    form: t.type({
        input: t.type({
            color: t.intersection([
                t.type({
                    dark: FormInputDarkColorPaletteWithNoAdditionalProperties,
                    default: t.unknown,
                    placeholder: t.unknown,
                    label: t.unknown,
                    error: t.unknown,
                    helper: t.unknown,
                    background: t.unknown,
                    border: t.unknown,
                    focus: t.unknown,
                }, 'color'),
                FormInputColorPalette,
            ]),
            typography: t.type({
                default: FontPropertiesAndDesktopAndNoAdditionalProperties,
                helper: FontPropertiesAndDesktopAndNoAdditionalProperties,
                label: FontPropertiesAndDesktopAndNoAdditionalProperties,
            }, 'typography'),
            border: t.type({
                radius: DesignTokenWithDimension,
                width: DesignTokenWithDimension,
                style: DesignTokenWithString,
            }, 'border'),
        }, 'input'),
    }, 'form'),
    grid: t.type({
        xs: BreakpointAndGutter,
        s: BreakpointAndGutter,
        m: BreakpointAndGutter,
        l: BreakpointAndGutter,
    }, 'grid'),
    label: t.type({
        typography: FontPropertiesAndNoAdditionalProperties,
        color: t.type({
            text: t.type({
                value: t.string,
            }, 'text'),
            dark: t.partial({
                text: t.type({
                    value: t.string,
                }, 'text'),
            }, 'dark'),
            recipe: t.type({
                text: t.type({
                    value: t.string,
                }, 'text'),
                background: t.type({
                    value: t.string,
                }, 'background'),
                dark: t.type({
                    text: t.type({
                        value: t.string,
                    }, 'text'),
                    background: t.type({
                        value: t.string,
                    }, 'background'),
                }, 'dark'),
            }, 'recipe'),
            informational: t.type({
                text: t.type({
                    value: t.string,
                }, 'text'),
                background: t.type({
                    value: t.string,
                }, 'background'),
                dark: t.type({
                    text: t.type({
                        value: t.string,
                    }, 'text'),
                    background: t.type({
                        value: t.string,
                    }, 'background'),
                }, 'dark'),
            }, 'informational'),
            outlined: t.type({
                text: t.type({
                    value: t.string,
                }, 'text'),
                background: t.type({
                    value: t.string,
                }, 'background'),
                border: t.type({
                    color: t.type({
                        value: t.string,
                    }, 'color'),
                    width: t.type({
                        value: t.string,
                    }, 'width'),
                    style: t.type({
                        value: t.string,
                    }, 'style'),
                }, 'border'),
                hover: t.type({
                    text: t.type({
                        value: t.string,
                    }, 'text'),
                    background: t.type({
                        value: t.string,
                    }, 'background'),
                    border: t.type({
                        color: t.type({
                            value: t.string,
                        }, 'color'),
                    }, 'border'),
                }, 'hover'),
                active: t.type({
                    text: t.type({
                        value: t.string,
                    }, 'text'),
                    background: t.type({
                        value: t.string,
                    }, 'background'),
                    border: t.type({
                        color: t.type({
                            value: t.string,
                        }, 'color'),
                    }, 'border'),
                }, 'active'),
                focus: t.type({
                    text: t.type({
                        value: t.string,
                    }, 'text'),
                    background: t.type({
                        value: t.string,
                    }, 'background'),
                    border: t.type({
                        color: t.type({
                            value: t.string,
                        }, 'color'),
                    }, 'border'),
                    outline: t.type({
                        color: t.type({
                            value: t.string,
                        }, 'color'),
                        width: t.type({
                            value: t.string,
                        }, 'width'),
                        style: t.type({
                            value: t.string,
                        }, 'style'),
                    }, 'outline'),
                }, 'focus'),
                dark: t.type({
                    text: t.type({
                        value: t.string,
                    }, 'text'),
                    background: t.type({
                        value: t.string,
                    }, 'background'),
                    border: t.type({
                        color: t.type({
                            value: t.string,
                        }, 'color'),
                        width: t.type({
                            value: t.string,
                        }, 'width'),
                        style: t.type({
                            value: t.string,
                        }, 'style'),
                    }, 'border'),
                    hover: t.type({
                        text: t.type({
                            value: t.string,
                        }, 'text'),
                        background: t.type({
                            value: t.string,
                        }, 'background'),
                        border: t.type({
                            color: t.type({
                                value: t.string,
                            }, 'color'),
                        }, 'border'),
                    }, 'hover'),
                    active: t.type({
                        text: t.type({
                            value: t.string,
                        }, 'text'),
                        background: t.type({
                            value: t.string,
                        }, 'background'),
                        border: t.type({
                            color: t.type({
                                value: t.string,
                            }, 'color'),
                        }, 'border'),
                    }, 'active'),
                    focus: t.type({
                        text: t.type({
                            value: t.string,
                        }, 'text'),
                        background: t.type({
                            value: t.string,
                        }, 'background'),
                        border: t.type({
                            color: t.type({
                                value: t.string,
                            }, 'color'),
                        }, 'border'),
                        outline: t.type({
                            color: t.type({
                                value: t.string,
                            }, 'color'),
                            width: t.type({
                                value: t.string,
                            }, 'width'),
                            style: t.type({
                                value: t.string,
                            }, 'style'),
                        }, 'outline'),
                    }, 'focus'),
                }, 'dark'),
            }, 'outlined'),
            filled: t.type({
                text: t.type({
                    value: t.string,
                }, 'text'),
                background: t.type({
                    value: t.string,
                }, 'background'),
                border: t.type({
                    color: t.type({
                        value: t.string,
                    }, 'color'),
                    width: t.type({
                        value: t.string,
                    }, 'width'),
                    style: t.type({
                        value: t.string,
                    }, 'style'),
                }, 'border'),
                hover: t.type({
                    text: t.type({
                        value: t.string,
                    }, 'text'),
                    background: t.type({
                        value: t.string,
                    }, 'background'),
                    border: t.type({
                        color: t.type({
                            value: t.string,
                        }, 'color'),
                    }, 'border'),
                }, 'hover'),
                active: t.type({
                    text: t.type({
                        value: t.string,
                    }, 'text'),
                    background: t.type({
                        value: t.string,
                    }, 'background'),
                    border: t.type({
                        color: t.type({
                            value: t.string,
                        }, 'color'),
                    }, 'border'),
                }, 'active'),
                focus: t.type({
                    text: t.type({
                        value: t.string,
                    }, 'text'),
                    background: t.type({
                        value: t.string,
                    }, 'background'),
                    border: t.type({
                        color: t.type({
                            value: t.string,
                        }, 'color'),
                    }, 'border'),
                    outline: t.type({
                        color: t.type({
                            value: t.string,
                        }, 'color'),
                        width: t.type({
                            value: t.string,
                        }, 'width'),
                        style: t.type({
                            value: t.string,
                        }, 'style'),
                    }, 'outline'),
                }, 'focus'),
                dark: t.type({
                    text: t.type({
                        value: t.string,
                    }, 'text'),
                    background: t.type({
                        value: t.string,
                    }, 'background'),
                    border: t.partial({
                        color: t.partial({
                            value: t.string,
                        }, 'color'),
                        width: t.partial({
                            value: t.string,
                        }, 'width'),
                        style: t.partial({
                            value: t.string,
                        }, 'style'),
                    }, 'border'),
                    hover: t.partial({
                        text: t.partial({
                            value: t.string,
                        }, 'text'),
                        background: t.partial({
                            value: t.string,
                        }, 'background'),
                        border: t.partial({
                            color: t.partial({
                                value: t.string,
                            }, 'color'),
                        }, 'border'),
                    }, 'hover'),
                    active: t.partial({
                        text: t.partial({
                            value: t.string,
                        }, 'text'),
                        background: t.partial({
                            value: t.string,
                        }, 'background'),
                        border: t.partial({
                            color: t.partial({
                                value: t.string,
                            }, 'color'),
                        }, 'border'),
                    }, 'active'),
                    focus: t.partial({
                        text: t.partial({
                            value: t.string,
                        }, 'text'),
                        background: t.partial({
                            value: t.string,
                        }, 'background'),
                        border: t.partial({
                            color: t.partial({
                                value: t.string,
                            }, 'color'),
                        }, 'border'),
                        outline: t.partial({
                            color: t.partial({
                                value: t.string,
                            }, 'color'),
                            width: t.partial({
                                value: t.string,
                            }, 'width'),
                            style: t.partial({
                                value: t.string,
                            }, 'style'),
                        }, 'outline'),
                    }, 'focus'),
                }, 'dark'),
            }, 'filled'),
        }, 'color'),
    }, 'label'),
    layout: t.type({
        homepage: ThemeSelector,
        'single-post': ThemeSelector,
        'single-post-affiliate': ThemeSelector,
        'single-page': ThemeSelector,
        'category-archive': ThemeSelector,
        'tag-archive': ThemeSelector,
        'search-page': ThemeSelector,
        newsletter: ThemeSelector,
        account: ThemeSelector,
    }, 'layout'),
    motion: t.type({
        speed: t.type({
            short: DesignTokenWithString,
            medium: DesignTokenWithString,
            long: DesignTokenWithString,
        }, 'speed'),
        curve: t.type({
            a: DesignTokenWithCubicBezier,
            b: DesignTokenWithCubicBezier,
            c: DesignTokenWithCubicBezier,
        }, 'curve'),
    }, 'motion'),
    navigation: t.type({
        color: t.type({
            border: DesignTokenWithColor,
            link: t.type({
                value: t.string,
                hover: DesignTokenWithColor,
                active: DesignTokenWithColor,
                focus: DesignTokenWithColor,
            }, 'link'),
        }, 'color'),
        typography: t.type({
            link: t.type({
                l1: FontPropertiesAndDesktopButNoFamilyAndNoAdditionalProperties,
                l2: FontPropertiesAndDesktopButNoFamilyAndNoAdditionalProperties,
            }, 'link'),
        }, 'typography'),
        border: t.type({
            style: DesignTokenWithString,
            width: DesignTokenWithDimension,
        }, 'border'),
        theme: Theme,
    }, 'navigation'),
    'newsletter-dropdown': t.type({
        color: t.type({
            background: DesignTokenWithColor,
        }, 'color'),
        'is-dark-theme': DesignTokenWithFlag,
    }, 'newsletter-dropdown'),
    newsletter: t.type({
        vertical: SpacingAndDesktopWithNoAdditionalProperties,
        color: t.type({
            text: DesignTokenWithColor,
            disclaimer: DesignTokenWithColor,
        }, 'color'),
        typography: t.type({
            title: FontPropertiesAndDesktopAndNoAdditionalProperties,
            disclaimer: t.intersection([
                t.intersection([
                    t.type({
                        focus: t.type({
                            outline: t.type({
                                color: DesignTokenWithColor,
                                value: t.string,
                            }, 'outline'),
                        }, 'focus'),
                    }),
                    t.partial({
                        desktop: t.unknown,
                        size: t.unknown,
                        weight: t.unknown,
                        lineHeight: t.unknown,
                        letterSpacing: t.unknown,
                        family: t.unknown,
                    }),
                ], 'disclaimer'),
                FontPropertiesAndDesktop,
            ]),
            subhead: FontPropertiesAndDesktopAndNoAdditionalProperties,
        }, 'typography'),
    }, 'newsletter'),
    outbrain: t.type({
        vertical: SpacingAndDesktopWithNoAdditionalProperties,
        color: t.type({
            background: DesignTokenWithColor,
        }, 'color'),
    }, 'outbrain'),
    'overlay-drawer': ThemeSelector,
    pagination: t.type({
        vertical: SpacingAndDesktopWithNoAdditionalProperties,
        color: t.type({
            default: DesignTokenWithColor,
            background: t.type({
                hover: DesignTokenWithColor,
            }, 'background'),
        }, 'color'),
        typography: FontPropertiesAndDesktopAndNoAdditionalProperties,
    }, 'pagination'),
    'post-divider': t.type({
        vertical: SpacingAndDesktopWithNoAdditionalProperties,
        color: DesignTokenWithColor,
        typography: t.type({
            text: FontPropertiesAndDesktopAndNoAdditionalProperties,
        }, 'typography'),
        dark: t.type({
            color: DesignTokenWithColor,
        }, 'dark'),
    }, 'post-divider'),
    'progress-bar': t.partial({
        color: t.partial({
            background: t.partial({
                value: t.string,
            }, 'background'),
        }, 'color'),
    }, 'progress-bar'),
    radius: t.partial({
        '0': DesignTokenWithDimension,
        '0-desktop': DesignTokenWithDimension,
        xs: DesignTokenWithDimension,
        'xs-desktop': DesignTokenWithDimension,
        s: DesignTokenWithDimension,
        's-desktop': DesignTokenWithDimension,
        m: DesignTokenWithDimension,
        'm-desktop': DesignTokenWithDimension,
        l: DesignTokenWithDimension,
        'l-desktop': DesignTokenWithDimension,
        xl: DesignTokenWithDimension,
        'xl-desktop': DesignTokenWithDimension,
        buttons: DesignTokenWithDimension,
        containers: DesignTokenWithDimension,
        media: DesignTokenWithDimension,
        icons: DesignTokenWithDimension,
        label: DesignTokenWithDimension,
    }, 'radius'),
    rem: t.type({
        value: t.string,
    }, 'rem'),
    separator: t.type({
        color: DesignTokenWithColor,
        thickness: DesignTokenWithDimension,
        dark: t.type({
            color: DesignTokenWithColor,
            thickness: DesignTokenWithDimension,
        }, 'dark'),
    }, 'separator'),
    spacing: t.type({
        '0': DesignTokenWithDimension,
        '0-desktop': DesignTokenWithDimension,
        '4xs': DesignTokenWithDimension,
        '4xs-desktop': DesignTokenWithDimension,
        '3xs': DesignTokenWithDimension,
        '3xs-desktop': DesignTokenWithDimension,
        '2xs': DesignTokenWithDimension,
        '2xs-desktop': DesignTokenWithDimension,
        xs: DesignTokenWithDimension,
        'xs-desktop': DesignTokenWithDimension,
        s: DesignTokenWithDimension,
        's-desktop': DesignTokenWithDimension,
        m: DesignTokenWithDimension,
        'm-desktop': DesignTokenWithDimension,
        l: DesignTokenWithDimension,
        'l-desktop': DesignTokenWithDimension,
        xl: DesignTokenWithDimension,
        'xl-desktop': DesignTokenWithDimension,
        '2xl': DesignTokenWithDimension,
        '2xl-desktop': DesignTokenWithDimension,
        '3xl': DesignTokenWithDimension,
        '3xl-desktop': DesignTokenWithDimension,
        '4xl': DesignTokenWithDimension,
        '4xl-desktop': DesignTokenWithDimension,
        '5xl': DesignTokenWithDimension,
        '5xl-desktop': DesignTokenWithDimension,
    }, 'spacing'),
    'split-hero': t.type({
        color: t.type({
            background: DesignTokenWithColor,
            text: DesignTokenWithColor,
            caption: DesignTokenWithColor,
            contributor: t.type({
                name: DesignTokenWithColor,
                role: DesignTokenWithColor,
            }, 'contributor'),
            link: t.type({
                value: t.string,
                hover: DesignTokenWithColor,
                active: DesignTokenWithColor,
                focus: DesignTokenWithColor,
            }, 'link'),
        }, 'color'),
        typography: t.type({
            title: t.type({
                size: DesignTokenWithDimension,
                weight: DesignTokenWithFontWeight,
                lineHeight: DesignTokenWithNumber,
                letterSpacing: DesignTokenWithDimension,
                family: DesignTokenWithFontFamily,
                desktop: t.type({
                    size: DesignTokenWithDimension,
                    weight: DesignTokenWithFontWeight,
                    lineHeight: DesignTokenWithNumber,
                    letterSpacing: DesignTokenWithDimension,
                    family: DesignTokenWithFontFamily,
                }, 'desktop'),
            }, 'title'),
            caption: t.type({
                size: DesignTokenWithDimension,
                weight: DesignTokenWithFontWeight,
                lineHeight: DesignTokenWithNumber,
                letterSpacing: DesignTokenWithDimension,
                family: DesignTokenWithFontFamily,
                desktop: t.type({
                    size: DesignTokenWithDimension,
                    weight: DesignTokenWithFontWeight,
                    lineHeight: DesignTokenWithNumber,
                    letterSpacing: DesignTokenWithDimension,
                    family: DesignTokenWithFontFamily,
                }, 'desktop'),
            }, 'caption'),
            contributor: t.type({
                name: t.type({
                    size: DesignTokenWithDimension,
                    weight: DesignTokenWithFontWeight,
                    lineHeight: DesignTokenWithNumber,
                    letterSpacing: DesignTokenWithDimension,
                    family: DesignTokenWithFontFamily,
                    focus: t.type({
                        outline: t.type({
                            color: DesignTokenWithColor,
                            value: t.string,
                        }, 'outline'),
                    }, 'focus'),
                    desktop: t.type({
                        size: DesignTokenWithDimension,
                        weight: DesignTokenWithFontWeight,
                        lineHeight: DesignTokenWithNumber,
                        letterSpacing: DesignTokenWithDimension,
                        family: DesignTokenWithFontFamily,
                    }, 'desktop'),
                }, 'name'),
                role: t.type({
                    size: DesignTokenWithDimension,
                    weight: DesignTokenWithFontWeight,
                    lineHeight: DesignTokenWithNumber,
                    letterSpacing: DesignTokenWithDimension,
                    family: DesignTokenWithFontFamily,
                    desktop: t.type({
                        size: DesignTokenWithDimension,
                        weight: DesignTokenWithFontWeight,
                        lineHeight: DesignTokenWithNumber,
                        letterSpacing: DesignTokenWithDimension,
                        family: DesignTokenWithFontFamily,
                    }, 'desktop'),
                }, 'role'),
            }, 'contributor'),
            subhead: FontPropertiesAndDesktopAndNoAdditionalProperties,
        }, 'typography'),
    }, 'split-hero'),
    theme: Theme,
    tooltip: t.type({
        background: DesignTokenWithColor,
        color: DesignTokenWithColor,
        dark: t.type({
            background: DesignTokenWithColor,
            color: DesignTokenWithColor,
        }, 'dark'),
    }, 'tooltip'),
    typography: t.partial({
        body: t.intersection([
            t.partial({
                s: FontPropertiesAndDesktopAndNoAdditionalProperties,
                desktop: t.unknown,
                size: t.unknown,
                weight: t.unknown,
                lineHeight: t.unknown,
                letterSpacing: t.unknown,
                family: t.unknown,
            }, 'body'),
            FontPropertiesAndDesktop,
        ]),
        btn: t.intersection([
            t.partial({
                desktop: FontPropertiesAndNoAdditionalProperties,
                link: Link,
                size: t.unknown,
                weight: t.unknown,
                lineHeight: t.unknown,
                letterSpacing: t.unknown,
                family: t.unknown,
            }, 'btn'),
            FontProperties,
        ]),
        caption: FontPropertiesAndDesktopAndNoAdditionalProperties,
        eyebrow: FontPropertiesAndDesktopAndNoAdditionalProperties,
        h: t.partial({
            '2xl': FontPropertiesAndDesktopAndNoAdditionalProperties,
            xl: FontPropertiesAndDesktopAndNoAdditionalProperties,
            l: FontPropertiesAndDesktopAndNoAdditionalProperties,
            m: FontPropertiesAndDesktopAndNoAdditionalProperties,
            s: FontPropertiesAndDesktopAndNoAdditionalProperties,
            xs: FontPropertiesAndDesktopAndNoAdditionalProperties,
            '2xs': FontPropertiesAndDesktopAndNoAdditionalProperties,
        }, 'h'),
        link: t.intersection([
            t.type({
                'text-decoration': DesignTokenWithString,
                desktop: t.intersection([
                    t.type({
                        'text-decoration': DesignTokenWithString,
                        size: t.unknown,
                        weight: t.unknown,
                        lineHeight: t.unknown,
                        letterSpacing: t.unknown,
                        family: t.unknown,
                    }, 'desktop'),
                    FontProperties,
                ]),
                size: t.unknown,
                weight: t.unknown,
                lineHeight: t.unknown,
                letterSpacing: t.unknown,
                family: t.unknown,
            }, 'link'),
            FontProperties,
        ]),
        subhead: FontPropertiesAndDesktopAndNoAdditionalProperties,
        typeface: t.partial({
            primary: Typeface,
            secondary: Typeface,
        }, 'typeface'),
    }, 'typography'),
}, 'DesignTokens');
export default DesignTokens;
// Success
//# sourceMappingURL=DesignTokens.js.map